import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { PackVerification_ModuleContextService } from './PackVerification.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class PackVerification_shipping_containers_to_verify_widget_ComponentContextService {
  private readonly moduleContext: PackVerification_ModuleContextService;

  constructor(moduleContext: PackVerification_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'shipping_containers_to_verify_widget',
      type: ComponentType.widget
    }
  }
}